import type { ReactNode } from "react";
import { useLocale } from "@/i18n";

type Props = {
  step: number;
  total: number;
  title: string;
  intro?: string;
  /** Optional element right of the title (e.g. a status pill). */
  aside?: ReactNode;
};

export function StepHeader({ step, total, title, intro, aside }: Props) {
  const { messages: m } = useLocale();
  return (
    <header className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        <p className="bk-eyebrow">{m.flow.stepOf(step, total)}</p>
        <h2 className="bk-step-title">{title}</h2>
        {intro ? <p className="bk-step-intro">{intro}</p> : null}
      </div>
      {aside ? <div className="shrink-0 pt-1">{aside}</div> : null}
    </header>
  );
}
